import { PageLoading } from '@ant-design/pro-components';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getLoginPathForTarget } from '@/apps/auth/utils/login';
import { authFreePaths } from '@/common/auth';
import { useAppContext } from '@/common/hooks/AppStateProvider';
import { stringifyQuery } from '@/common/utils/query';

const AuthGuard = () => {
  const location = useLocation();
  const { session } = useAppContext();

  if (session.status === 'loading') {
    return <PageLoading />;
  }

  if (session.status === 'authenticated') {
    return <Outlet />;
  }

  if (authFreePaths.has(location.pathname)) {
    return <Outlet />;
  }

  const redirect = `${location.pathname}${location.search}`;
  return (
    <Navigate
      to={`${getLoginPathForTarget(location.pathname)}?${stringifyQuery({ redirect })}`}
      replace
    />
  );
};

export default AuthGuard;
